import React, { useCallback, useRef, useState } from 'react';
import {
  ModalWrapper,
  CloseButtonWrapper,
  ModalImage,
  ButtonWrapper,
} from './styled';
import { createPortal } from 'react-dom';
import { Button, CloseButton, PlusButton } from 'components';
import { useOutsideClick } from 'hooks';
import { ResetIcon } from 'static';

const ImageModal = ({ isOpen, imgSrc, altText, onClose }) => {
  const [zoomLevel, setZoomLevel] = useState(1);
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, onClose);

  const handleZoomIn = useCallback(
    () => setZoomLevel((prev) => Math.min(prev + 0.2, 3)),
    [],
  );

  const handleZoomOut = useCallback(
    () => setZoomLevel((prev) => Math.max(prev - 0.2, 1)),
    [],
  );

  const resetZoom = useCallback(() => setZoomLevel(1), []);

  return isOpen === true
    ? createPortal(
        <ModalWrapper>
          <CloseButtonWrapper>
            <CloseButton
              style={{ width: '40px', height: '40px' }}
              hidden={false}
              onClick={onClose}
              height="16px"
              width="16px"
            />
          </CloseButtonWrapper>
          <div
            style={{ position: 'relative', height: '100%', display: 'flex' }}
            ref={wrapperRef}
          >
            <ModalImage
              src={imgSrc}
              alt={altText}
              style={{
                transform: `scale(${zoomLevel})`,
                transition: 'transform 0.3s ease',
                cursor: zoomLevel > 1 ? 'move' : 'default',
              }}
            />
            <ButtonWrapper>
              <PlusButton
                width="40px"
                contained={true}
                onClick={handleZoomOut}
                isMinusIcon
              />
              <Button onClick={resetZoom} variant="secondary" width="80px">
                <ResetIcon width="40px" height="40px" />
              </Button>
              <PlusButton
                width="40px"
                contained={true}
                onClick={handleZoomIn}
              />
            </ButtonWrapper>
          </div>
        </ModalWrapper>,
        document.getElementById('modal'),
      )
    : null;
};

export default ImageModal;
